<template>
  <div class="comp-menu">
    <div class="menu-items">
      <div class="menu-category">Site</div>
      <div 
      ontouchstart=""
      v-for="(site, siteId) in mySites"
      v-bind:key="siteId"
      v-on:click="selectSite(siteId)"
      class="menu-item">
        <div class="menu-icon">
          <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
            <path d="M0 0h24v24H0z" fill="none"/>
          </svg>
        </div>
        <div class="menu-info">
          <div class="main-info">{{site.name}}</div>
          <div class="sub-info">{{site.address}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'comp-menu',
  computed: {
    mySites: function () {
      return this.$store.getters.mySites
    }
  },
  methods: {
    selectSite: function (siteId) {
      this.$store.dispatch('selectSite', siteId)
      this.$store.commit('CLOSE_MENU')
      this.$router.push({name: 'cameras', params: { siteId: siteId }})
    }
  }
}
</script>

<style scoped>
  .comp-menu {
    font-size: 16px;
    width: 300px;
    border-right: 1px solid hsl(210,30%,5%);
    height: calc(100% - 2em);
    position: absolute;
    z-index: 1000;
    left: 0;
    top: 0;
    background-color: hsl(210,10%,10%);
    color: #fff;
    padding: 1em 0;
    transform: translateX(-100%);
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: ms-autohiding-scrollbar;
  }
  .comp-menu::-webkit-scrollbar {
    display: none;
  } 
  .comp-menu .menu-items {
    text-align: left;
    padding: 0;
  }
  .comp-menu .menu-items .menu-category {
    font-size: 0.8em;
    padding: 1em 1.2em;
    text-transform: uppercase;
    margin-top: 2em;
    color: hsl(204, 60%, 50%);
    font-weight: bold;
  }
  .comp-menu .menu-items .menu-item {
    padding: 1em;
    margin: 1px 0;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: rgba(255,255,255,0.04);
    transition: background .2s;
  }
  .comp-menu .menu-items .menu-item:hover {
    background-color: rgba(255,255,255,0.06);
  }
  .comp-menu .menu-items .menu-item:active {
    background-color: rgba(255,255,255,0.08);
  }
  .comp-menu .menu-items .menu-item.selected {
    background-color: rgba(255,255,255,0.2);
  }
  .comp-menu .menu-items .menu-item.selected:hover:active {
    background-color: rgba(255,255,255,0.2);
  }

  .comp-menu .menu-items .menu-item .menu-icon {
    position: relative;
    color: hsl(204, 60%, 50%);
    margin-right: 1em;
    width: 24px;
    height: 24px;
  }
  .comp-menu .menu-items .menu-item .menu-icon svg {
    fill: currentColor;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 24px;
    height: 24px;
  }
  .comp-menu .menu-items .menu-item .menu-info {
    padding: 0;
    width: calc(100% - 24px - 1em);
  }
  .comp-menu .menu-items .menu-item .menu-info .main-info {
    padding: 0;
    /* margin-bottom: 0.3em; */
  }
  .comp-menu .menu-items .menu-item .menu-info .sub-info {
    padding: 0;
    font-size: 0.7em;
    opacity: 0.6;
    text-transform: uppercase;
  }
  .comp-menu .menu-items .menu-item.offline {
    color: rgba(255,255,255,0.25);
  }
  .comp-menu .menu-items .menu-item.offline .menu-icon {
    color: rgba(255,255,255,0.25);
  }

</style>



// WEBPACK FOOTER //
// CompMenu.vue?06b6d962